import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, MapPin, Mail } from 'lucide-react';
import { contactInfo } from '../data/mock';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-blue-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          {/* About */}
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <img 
                src="/images/Raj Canine Logo - Edited.png"
                alt="Raj Canine Care Logo"
                className="h-12 w-auto"
              />
              <div>
                <h3 className="text-lg font-bold">Raj Canine Care</h3>
              </div>
            </div>
            <p className="text-blue-200 text-sm leading-relaxed">
              Complete care for dogs and cats. Compassionate veterinary care, professional grooming, and premium pet products.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/"
                  className="text-blue-200 hover:text-yellow-400 transition-colors duration-200 text-sm"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-blue-200 hover:text-yellow-400 transition-colors duration-200 text-sm"
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link
                  to="/services"
                  className="text-blue-200 hover:text-yellow-400 transition-colors duration-200 text-sm"
                >
                  Services
                </Link>
              </li>
              <li>
                <Link
                  to="/why-us"
                  className="text-blue-200 hover:text-yellow-400 transition-colors duration-200 text-sm"
                >
                  Why Us
                </Link>
              </li>
              <li>
                <Link
                  to="/reviews"
                  className="text-blue-200 hover:text-yellow-400 transition-colors duration-200 text-sm"
                >
                  Reviews
                </Link>
              </li>
              <li>
                <Link
                  to="/warning-signs"
                  className="text-blue-200 hover:text-yellow-400 transition-colors duration-200 text-sm"
                >
                  Warning Signs
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-blue-200 hover:text-yellow-400 transition-colors duration-200 text-sm"
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-bold mb-4">Our Services</h4>
            <ul className="space-y-2 text-sm text-blue-200">
              <li>Veterinary OPD</li>
              <li>Vaccination Programs</li>
              <li>Professional Grooming</li>
              <li>Pet Nutrition</li>
              <li>Pet Accessories</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-bold mb-4">Contact Info</h4>
            <div className="space-y-3">
              <div className="flex items-start space-x-2">
                <MapPin className="w-5 h-5 text-yellow-400 flex-shrink-0 mt-1" />
                <a 
                  href="https://maps.app.goo.gl/VhzQRjVcD9MzRe8i8"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-blue-200 hover:text-yellow-400 transition-colors duration-200"
                >
                  {contactInfo.address}
                </a>
              </div>
              <div className="flex items-start space-x-2">
                <Phone className="w-5 h-5 text-yellow-400 flex-shrink-0 mt-1" />
                <div className="text-sm">
                  {contactInfo.phones.map((phone, index) => (
                    <a 
                      key={index}
                      href={`tel:${contactInfo.phoneLinks[index]}`}
                      className="text-blue-200 hover:text-yellow-400 transition-colors duration-200 block"
                    >
                      {phone}
                    </a>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-blue-800 mt-8 pt-8 text-center">
          <p className="text-blue-200 text-sm">
            © {currentYear} Raj Canine Care. All rights reserved. Made with care for pets.
          </p>
        </div>
      </div>
    </footer>
  );
};